module.exports = __webpack_public_path__ + "KR.png?7e83001f0b0180dd214fdded15f3dbfe";